/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Workflow_Step1body1Inputs */

const zh_landing_workflow_step1body1 = /** @type {(inputs: Landing_Workflow_Step1body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据课程大纲生成幻灯片、练习单和教案。`)
};

const en_landing_workflow_step1body1 = /** @type {(inputs: Landing_Workflow_Step1body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate slides, worksheets and lesson plans aligned to your curriculum.`)
};

const es_landing_workflow_step1body1 = /** @type {(inputs: Landing_Workflow_Step1body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera diapositivas, hojas de trabajo y planes de clase alineados a tu currículo.`)
};

/**
* | output |
* | --- |
* | "Generate slides, worksheets and lesson plans aligned to your curriculum." |
*
* @param {Landing_Workflow_Step1body1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_workflow_step1body1 = /** @type {((inputs?: Landing_Workflow_Step1body1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Workflow_Step1body1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_workflow_step1body1(inputs)
	if (locale === "en") return en_landing_workflow_step1body1(inputs)
	return es_landing_workflow_step1body1(inputs)
});
export { landing_workflow_step1body1 as "landing_workflow_step1Body" }